module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253061973_Preface#sec1"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253061973_Introduction#sec2"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253061973_Chapter01#sec3"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("Kaiser Wilhelm’s Legacy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253061973_Chapter02#sec4"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("The Eloquent Artist")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253061973_Chapter03#sec5"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("The Champagne Salesman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Chapter04#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("Fat Boy’s Swedish Friend")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Chapter05#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("“Close Your Hearts to Pity!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Chapter06#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("A Performance of Bombast and Threats")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Chapter07#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("“A Second Bismarck”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Chapter08#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("Et Tu, Bruté?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Chapter09#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("“It’s Enough to Kill a Bull”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1",
    attrs: {
      "id": "rsec12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Chapter10#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("The Speech That Fell Flat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1",
    attrs: {
      "id": "rsec13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Chapter11#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("Into the Wee Hours")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1",
    attrs: {
      "id": "rsec14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Chapter12#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("A Shouting Match")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1",
    attrs: {
      "id": "rsec15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Chapter13#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("“Where Is the Pole?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1",
    attrs: {
      "id": "rsec16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Chapter14#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("The Intercepted Telegram")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1",
    attrs: {
      "id": "rsec17"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Chapter15#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("Invasion")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1",
    attrs: {
      "id": "rsec18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Chapter16#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("Ultimatum")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch1",
    attrs: {
      "id": "rsec19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Chapter17#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17"), _c('span', {
    staticClass: "spacel"
  }, [_vm._v("Finis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm1",
    attrs: {
      "id": "rsec20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Notes#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "rsec21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Bibliography#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm",
    attrs: {
      "id": "rsec22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253061973_Index#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c9bd435","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253061973_Contents.vue
// module id = 69
// module chunks = 0